import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-react";
import { ContactsOutlined } from "@material-ui/icons";
import Button from "components/CustomButton/CustomButton.jsx";
import FormInputs from "components/FormInputs/FormInputs.jsx";
import React, { useState } from "react";
import { Col, ControlLabel, FormGroup, Modal, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import { trackPromise } from "react-promise-tracker";
import "react-quill/dist/quill.snow.css";
import api from "services/api.jsx";
import styles from "./styles.module.css";

const Store = ({ onClose = () => { }, idCandidato, nomeCandidato }) => {
  const [show, setShow] = useState(true);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [video, setVideo] = useState();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image_header, setImageHeader] = useState(null);
  const [is_active, setIsActive] = useState("true");

  const handleClose = () => {
    onClose();
    setShow(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("is_active", is_active === "true" ? 1 : 0);

    if (image_header) {
      formData.append("image_header", image_header, image_header.name);
    }

    if (video) {
      formData.append("video", video);
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const url =
      idCandidato > 0
        ? `/${localStorage.getItem("idApp")}/candidates/${idCandidato}/news`
        : `/news/${localStorage.getItem("idApp")}`;

    trackPromise(
      api
        .post(url, formData, config)
        .then((response) => {
          onClose();
        })
        .catch((error) => {
          if (error.response.data.errors) {
            if (error.response.data.errors.title)
              setErrorText(error.response.data.errors.title[0]);
            if (error.response.data.errors.content)
              setErrorText(error.response.data.errors.content[0]);
            if (error.response.data.errors.candidate)
              setErrorText(error.response.data.errors.candidate[0]);
          } else {
            setErrorText(error.response.data.message);
          }
          setIsAlertVisible(true);
        })
    );
  };

  return (
    <>
      <Modal
        size="large"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Nova Noticia - {nomeCandidato}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitHandler} encType="multipart/form-data">
            {isAlertVisible && (
              <div className="alert alert-danger">
                Error no cadastro da noticia!
                <br />
                ERROR: {errorText}
              </div>
            )}
            <FormInputs
              ncols={["col-md-12"]}
              properties={[
                {
                  label: "Título",
                  type: "text",
                  bsClass: "form-control",
                  placeholder: "Título",
                  required: true,
                  defaultValue: title,
                  maxLength: 100,
                  name: "title",
                  onChange: (event) => setTitle(event.target.value),
                },
              ]}
            />

            <Row className={styles.alignCenter}>
              <Col md={12}>
                <div className="form-group">
                  <label>Link do vídeo</label>
                  <input
                    type="text"
                    className="form-control"
                    name="video"
                    placeholder="Link vídeo (opcional)"
                    value={video}
                    onChange={(event) => setVideo(event.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={6}>
                <FormInputs
                  ncols={["col-md-6"]}
                  properties={[
                    {
                      label: "Imagem",
                      type: "file",
                      bsClass: "form-control",
                      defaultValue: image_header,
                      required: true,
                      name: "image_header",
                      onChange: (event) =>
                        setImageHeader(event.target.files[0]),
                    },
                  ]}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup controlId="formControlsTextarea">
                  <ControlLabel>Conteúdo</ControlLabel>
                  <ReactQuill
                    theme="snow"
                    value={content}
                    onChange={(value) => setContent(value)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                      ],
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <div className="form-group">
                  <label className="">Visibilidade</label>
                  <select
                    name="isActive"
                    onChange={(event) => setIsActive(event.target.value)}
                    className="form-control"
                    required
                  >
                    <option value="true">Visível</option>
                    <option value="false">Oculta</option>
                  </select>
                </div>
              </Col>
            </Row>
            <Button bsStyle="danger" fill onClick={() => onClose()}>
              Cancelar
            </Button>
            <Button bsStyle="info" pullRight fill type="submit">
              Salvar
            </Button>
            <div className="clearfix" />
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Store;
